import React from 'react'

export enum SettingsTab {
  Chart = 'chart',
  Colors = 'colors',
}

export type ChartLayoutProps = {
  config: object
  onRegisterChartLayoutModel?: (chartLayout: any) => void
  shouldResize?: boolean
  parentElement?: HTMLElement
}

export type ChartLayoutHeaderProps = {
  model: any
  onSettingsOpen: () => void
  hasPublish: boolean
}

interface ChartsLib {
  FREE_DATE_RANGES: string[]
  ChartLayout: React.FC<ChartLayoutProps>
  ChartLayoutHeader: React.FC<ChartLayoutHeaderProps>
  ChartLayoutWithGlobalState: React.FC<ChartLayoutProps>

  ChartSettings: React.FC<{
    onClose: () => void
    onActiveSettingsTabChange?: (settingsComponent: SettingsTab) => void
    activeSettingsTab?: SettingsTab
  }>

  PreventClosingUnsavedChanges: React.FC<{
    onHide: () => void
    children: (props: { checkForUnsavedChangesAndClose: () => void }) => React.ReactElement
  }>

  useChartLayoutGlobalModel: () => {
    chartLayoutModel: any | null
    chartLayoutModelConfigSnapshot: Record<string, any> | null
    lastGlobalRerender: number
    setChartLayoutModel: (chartLayoutModel: any) => void
    getChartLayoutModelConfig: (props: { fallback: Record<string, any> }) => Record<string, any>
    forceGlobalRerender: () => void
    generateNewLayoutModelConfigSnapshot: () => void
  }

  StockDetailTimeframeBar: React.FC<{
    isDateRangeAvailable: boolean
    isPremium: boolean
    isLoadingOverride?: boolean
  }>

  Quote: {
    create(quote: any): any
    select: (query: (quote: any) => boolean) => any
    deleteAll: () => void
    findByAttribute: (attribute: string, value: any) => any
    getAll: (tickersAndTimeframes: any) => any
  }

  Settings: {
    MarketSentiment: any
    Indicator: any
    Chart: any
    Thumb: any
    Element: any
    Colors: string[]
    updateColors: (type: string, name: string, theme: 'light' | 'dark', value: string) => void
  }

  Utils: {
    dateFromUnixTimestamp: (date: string) => Date
  }

  convertTa: {
    getPanes: (taConfig: any) => any
  }

  useModelState: <Model>(
    model: Model | null,
    options: { watchProperties?: Array<keyof Model>; listenOnEvents?: string[] }
  ) => Model | null
}

// @ts-ignore
const chartsLib = (window.FLibs.Charts as ChartsLib) ?? {}

export const FREE_DATE_RANGES = chartsLib.FREE_DATE_RANGES
export const ChartLayout = chartsLib.ChartLayout
export const ChartLayoutWithGlobalState = chartsLib.ChartLayoutWithGlobalState
export const ChartLayoutHeader = chartsLib.ChartLayoutHeader
export const ChartSettings = chartsLib.ChartSettings
export const PreventClosingUnsavedChanges = chartsLib.PreventClosingUnsavedChanges
export const useChartLayoutGlobalModel = chartsLib.useChartLayoutGlobalModel
export const StockDetailTimeframeBar = chartsLib.StockDetailTimeframeBar
export const Quote = chartsLib.Quote
export const Settings = chartsLib.Settings
export const Utils = chartsLib.Utils
export const convertTa = chartsLib.convertTa
export const useModelState = chartsLib.useModelState
